import React from 'react';
import config from '../../services/config.json';


const CustomerAct = ({ ActName, ImgUrl}) => { 

    return (
        <React.Fragment>
            <div className="item " >
                <img className="cat2_img" 
                src={`${config.customersActPictures}/${ImgUrl}.jpg`}
                alt=""
                />
            </div>
            {/* <div className="second-txt-Acts text-center" >
                <p style={{color:"white"}}>{`${ActName}`}</p>
            </div> */}
        </React.Fragment>
        );
}
 
export default CustomerAct;